




















import { Component, Prop, Vue } from "vue-property-decorator";

// Types
import { IPromotion } from "@/models/promotions";

@Component
export default class PromotionStatusSummary extends Vue {
  // Props

  @Prop({ required: true })
  public promotion!: IPromotion;

  // Computed

  public get isExpired() {
    if (this.$_.isNull(this.promotion.to_date)) return false;

    return this.$moment(this.promotion.to_date)
      .local()
      .isBefore(new Date());
  }

  public get expiresSoon() {
    return (
      !this.$_.isNull(this.promotion.to_date) &&
      this.$moment(this.promotion.to_date)
        .local()
        .isAfter(new Date())
    );
  }

  public get isNotStarted() {
    if (this.$_.isNull(this.promotion.from_date)) return false;

    return this.$moment(this.promotion.from_date)
      .local()
      .isAfter(new Date());
  }

  public get summary() {
    if (this.promotion.hidden)
      return {
        path: "_.deleted",
        class: "has-text-danger",
        icon: "trash-alt"
      };

    if (!this.promotion.active)
      return {
        path: "_.inactive",
        class: "has-text-grey",
        icon: "times-circle"
      };

    if (this.isExpired)
      return {
        path: "_.active_expired",
        class: "has-text-warning",
        date: this.promotion.to_date,
        formatFunction: "fromNow",
        formatFunctionParams: true,
        icon: "hourglass-end"
      };

    if (this.isNotStarted)
      return {
        path: "_.active_starts",
        class: "has-text-success",
        date: this.promotion.from_date,
        formatFunction: "fromNow",
        formatFunctionParams: true,
        icon: "hourglass-start"
      };

    if (this.expiresSoon)
      return {
        path: "_.active_expires",
        class: "has-text-success",
        date: this.promotion.to_date,
        formatFunction: "fromNow",
        formatFunctionParams: true,
        icon: "hourglass-half"
      };

    return {
      path: "_.active",
      class: "has-text-success",
      icon: "check-circle"
    };
  }
}
